


(function ($) {
    $(function () {

        if ($('.js-map-marker').length > 0) {

            $('.js-map-marker').on('mouseenter', function () {
                let markers = $('.js-map-marker');
                markers.removeClass('bounce');

                $(this).addClass('js-marker-hover-active');
            });

            $('.js-map-marker').on('mouseleave', function () {
                $(this).removeClass('js-marker-hover-active');
            });

            setInterval(function () {
                let markers = $('.js-map-marker');
                if ($('.js-marker-hover-active').length > 0 || $('.js-marker-active').length > 0) {
                    return;
                }

                let index = Math.floor(Math.random() * markers.length);
                markers.removeClass('bounce');
                $(markers[index]).addClass('bounce');
            }, 3000);


            $('.js-project-close').on('click', function () {

                if (typeof gsap === 'undefined') {
                    return;
                }

                const marker = $('.js-marker-active');
                const project_card = $('.js-card-active');

                if (project_card.length > 0) {
                    if ($('.js-card-active').length > 0) {
                        gsap.to('.js-card-active', { transformOrigin: '50% 50%', translateX: `0`, duration: 1 })
                        $('.js-card-active').removeClass('js-card-active');
                    }
                }

                if (marker.length) {
                    gsap.to(".js-marker-active", { transformOrigin: '50% 50%', scale: 1, translateY: '0' });
                    marker.removeClass('js-marker-active');
                }
            })


            $('.js-map-marker').on('click', function () {

                if ($(this).hasClass('js-marker-active')) {
                    return;
                }

                $('.js-map-marker').removeClass('js-marker-active');

                $(this).addClass('js-marker-active')
                $(project_card).addClass('js-marker-active')

                if (typeof gsap === 'undefined') {
                    return;
                }

                const project_id = $(this).data('project');
                const project_card = $(`.project-card[data-mapid="${project_id}"]`);

                let mm = gsap.matchMedia();

                mm.add({
                    desktopXxl: `(min-width: 1400px)`,
                    desktopXl: `(min-width: 992px)`,
                    desktopMd: `(min-width: 768px)`,
                    desktopSm: `(max-width: 767px)`,
                }, (context) => {
                    let { desktopXxl, desktopXl, desktopMd, desktopSm } = context.conditions;

                    gsap.to(".js-map-marker + .map-marker", { transformOrigin: '50% 50%', scale: 1, translateY: '0' })
                    gsap.to(".js-map-marker + .map-marker + path", { transformOrigin: '50% 50%', scale: 1, translateY: '0' })

                    if (desktopXxl) {
                        gsap.to("#project-map", { transformOrigin: '50% 50%', translateX: '-335px', duration: 0.5 })
                    } else {

                        if (desktopXl) {
                            gsap.to("#project-map", { transformOrigin: '50% 50%', translateX: '-220px', duration: 0.5 })
                        } else {

                            if (desktopMd) {
                                gsap.to("#project-map", { transformOrigin: '50% 50%', translateX: '-150px', duration: 0.5 })
                            }
                        }

                    }

                    if ($('.js-marker-active').length) {
                        gsap.to(".js-marker-active + .map-marker", { transformOrigin: '50% 50%', scale: 1.5, translateY: '-40px' })
                        gsap.to(".js-marker-active + .map-marker + path", { transformOrigin: '50% 50%', scale: 1.2, translateY: '-20px' })
                    }

                    if (project_card.length > 0) {
                        if ($('.js-card-active').length > 0) {
                            gsap.to('.js-card-active', { transformOrigin: '50% 50%', translateX: `0`, duration: 1 })
                            $('.js-card-active').removeClass('js-card-active');
                        }

                        $(project_card).addClass('js-card-active')
                        gsap.to(project_card, { transformOrigin: '50% 50%', translateX: `-${project_card.width()}px`, duration: 0.5 })
                    }

                });

            });


        }

        if($('.js-projects-decor-anim').length) {
            gsap.registerPlugin(ScrollTrigger);

            let firstIconAnimation = gsap.timeline({
                defaults: { duration: 2 } // Hosszabb animációs idő minden elemhez
            });
            
            firstIconAnimation.to('#calculator', {
                y: 10
            }, 0);
            
            firstIconAnimation.to('#heart', {
                y: 30
            }, 0);
            
            ScrollTrigger.create({
                trigger: '.js-projects-decor-anim',
                start: 'top center', // Akkor indul el, amikor a trigger a képernyő közepére ér
                animation: firstIconAnimation,
                scrub: 2 // Lassabb, finomabb görgetés alapú animáció
            });
    
            let secondIconAnimation = gsap.timeline({
                defaults: { duration: 2 } // Hosszabb animációs idő minden elemhez
            });
            
            secondIconAnimation.to('#keys', {
                y: 20
            }, 0);
          
            ScrollTrigger.create({
                trigger: '.js-projects-decor-anim-2',
                start: 'top center', // Akkor indul el, amikor a trigger a képernyő közepére ér
                animation: secondIconAnimation,
                scrub: 2 // Lassabb, finomabb görgetés alapú animáció
            });
            
        }
    });
})(jQuery);
